import { Box, Typography, Grid } from "@mui/material";

export const PastTrips = () => {
    return (
        <Box maxWidth="xl">
            <Typography
                variant="h6"
                className="trp"
                sx={{
                    fontSize: "14px",
                    marginTop: "5%",
                    marginBottom: "2%"
                }}
            >
                Past Trips
            </Typography>

            <Grid container spacing={2}>
                {[1, 2].map((item) => (
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6} key={item}>
                        <Box>
                            <img src={require(`../../assets/images/past.png`)} alt={`Past Trip ${item}`} style={{ width: "100%" }} />
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
